module.exports = __webpack_public_path__ + "static/artist-flexi-contract-2018-47992e6855d0b5c2cfbe412821b3af9d.pdf";